<template>
  <div class="index">
    <app-header head-title="用户中心"></app-header>
    <div class="centerPart">
      <app-sidebar :userInfo="userInfo" :style="{height:rightHeight}"></app-sidebar>
      <div class="right-content" ref="content">
        <router-view :userInfo="userInfo" @resetHeightFn="resetHeightFn"></router-view>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<script>
import user from "@/api/user";
// import banBack from "@/utils/banBack";
import header from "@/components/common/header";
import footer from "@/components/common/footer";
import sidebar from "@/components/common/sidebar";

export default {
  name: "index",
  components: {
    "app-header": header,
    "app-footer": footer,
    "app-sidebar": sidebar
  },
  data() {
    return {
      userInfo: {},
      rightHeight: 650
    };
  },
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background:#f3f2f0");
  },
  beforeDestroy() {
    // document.querySelector("body").removeAttribute("style");
  },
  created() {
    this.checkLoginState();
  },
  mounted() {},
  methods: {
    resetHeightFn() {
      this.rightHeight = this.$refs.content.scrollHeight + "px";
    },
    checkLoginState() {
      user
        .getUserInfo()
        .then(result => {
          this.userInfo = result.data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss">
.index {
  // background-color: #f3f2f0;
  .centerPart {
    overflow: hidden;
    zoom: 1;
    margin: 40px auto 30px;
    width: 1000px;
    min-height: 650px;
  }
  .right-content {
    background-color: #fff;
    margin-left: 40px;
    float: left;
    min-height: 650px;
    width: 720px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue